// extracted by mini-css-extract-plugin
export default {"requisitionContainer":"RequisitionSearch_requisitionContainer__vnieZ","noData":"RequisitionSearch_noData__98nHA","widthbutton":"RequisitionSearch_widthbutton__CGtfZ"};